import React, { FC } from "react";
import Link from "next/link";
import { useLocale, useTranslations } from "next-intl";

import { useTheme } from "@/context/Theme.context";
import NavbarDropdown from "./navbar-dropdown/navbar-dropdown";
import { authNavitems, getCountrySpecificUrl } from "./utils/authNavItems";
import { Theme } from "@/enums";

const AuthNavbar: FC = () => {
  const t = useTranslations();
  const theme = useTheme();
  const locale = useLocale();

  const countryCode =
    theme === Theme.GEORGIA ? "ge" : theme === Theme.UZ ? "uz" : "uk";

  return (
    <nav>
      <ul className="hidden items-center gap-4 lg:flex xl:gap-6 2xl:gap-[35px]">
        {authNavitems
          .filter(
            (item) => item.isDropdown || item.href?.[countryCode] !== null,
          )
          .map((item) => {
            const isDropdown = item?.isDropdown && !item.href?.[countryCode];

            return (
              <li key={item.name}>
                {isDropdown ? (
                  <NavbarDropdown
                    name={t(item.name)}
                    list={item.children}
                    countryCode={countryCode}
                  />
                ) : (
                  <Link
                    href={getCountrySpecificUrl(
                      countryCode,
                      item.href[countryCode],
                      locale,
                    )}
                    target="_blank"
                    className="font-normal text-black 2xl:text-lg"
                  >
                    {t(item.name)}
                  </Link>
                )}
              </li>
            );
          })}
      </ul>
    </nav>
  );
};

export default AuthNavbar;
